import { render, staticRenderFns } from "./RatingInput.vue?vue&type=template&id=11edac2e&scoped=true&"
import script from "./RatingInput.vue?vue&type=script&lang=js&"
export * from "./RatingInput.vue?vue&type=script&lang=js&"
import style0 from "./RatingInput.vue?vue&type=style&index=0&id=11edac2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11edac2e",
  null
  
)

export default component.exports